import styled from "styled-components";

const Wrapper = styled.div`
  padding: 16px;
  padding-top: 22px;
  font-size: 13px;
  color: #7b7b7b;
  line-height: 16px;
  
  ul, ol {
    padding-left: 0;
    list-style: initial;
  }
`;

export default Wrapper;